import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Icon from "./Icons";

function AdminPasswordReset() {
  const [form, setForm] = useState({ adminKey: "", email: "", password: "", confirmPassword: "" });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const updateField = event => {
    setForm(current => ({ ...current, [event.target.name]: event.target.value }));
  };

  const handleSubmit = async event => {
    event.preventDefault();
    setError("");
    setMessage("");

    if (form.password.length < 8) {
      setError("Use at least 8 characters for the new password.");
      return;
    }
    if (form.password !== form.confirmPassword) {
      setError("The new passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      const { data } = await axios.post("/api/user/admin-reset-password", {
        adminKey: form.adminKey,
        email: form.email,
        password: form.password,
      });
      setMessage(data.message);
      setForm(current => ({ ...current, password: "", confirmPassword: "" }));
    } catch (requestError) {
      setError(requestError.response?.data?.message || "The password could not be reset.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-[calc(100vh-4rem)] items-center justify-center px-5 py-14">
      <div className="w-full max-w-md">
        <Link to="/login" className="mb-9 inline-flex items-center gap-2 text-sm text-cream-muted no-underline transition-colors hover:text-cream">
          <Icon name="arrow" className="rotate-180" size={15} /> Back to sign in
        </Link>
        <p className="sc-kicker mb-3">Private administration</p>
        <h1 className="font-serif text-4xl font-semibold tracking-[-0.03em] text-cream">Reset an account.</h1>
        <p className="mt-2 text-sm leading-relaxed text-cream-muted">Use your master recovery key to assign a new password. This page is intentionally not linked in the product navigation.</p>

        <form onSubmit={handleSubmit} className="sc-panel mt-8 space-y-5 p-6 sm:p-7">
          {error && <div className="rounded-xl border border-crimson/30 bg-crimson/10 px-4 py-3 text-sm text-crimson-light">{error}</div>}
          {message && <div className="rounded-xl border border-gold/25 bg-gold/10 px-4 py-3 text-sm text-gold-light">{message}</div>}

          <div>
            <label className="mb-1.5 block text-xs font-medium text-cream-dim" htmlFor="admin-key">Master recovery key</label>
            <input id="admin-key" name="adminKey" type="password" value={form.adminKey} onChange={updateField} className="sc-input" autoComplete="off" required />
          </div>
          <div>
            <label className="mb-1.5 block text-xs font-medium text-cream-dim" htmlFor="account-email">Account email</label>
            <input id="account-email" name="email" type="email" value={form.email} onChange={updateField} placeholder="reader@example.com" className="sc-input" required />
          </div>
          <div>
            <label className="mb-1.5 block text-xs font-medium text-cream-dim" htmlFor="admin-new-password">New password</label>
            <input id="admin-new-password" name="password" type="password" value={form.password} onChange={updateField} placeholder="At least 8 characters" className="sc-input" minLength={8} required />
          </div>
          <div>
            <label className="mb-1.5 block text-xs font-medium text-cream-dim" htmlFor="admin-confirm-password">Confirm new password</label>
            <input id="admin-confirm-password" name="confirmPassword" type="password" value={form.confirmPassword} onChange={updateField} placeholder="Repeat the new password" className="sc-input" minLength={8} required />
          </div>
          <button type="submit" disabled={loading} className="sc-btn-gold w-full py-3 disabled:opacity-50">
            {loading ? "Resetting password…" : "Reset password"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminPasswordReset;
